// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Khtd7","disabled":"FileBtn_disabled__14l_k","warn":"FileBtn_warn__Fst__","fade":"FileBtn_fade__30qpU"};